package com.hyperether.goodjob.scenes.addNew

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.Divider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Sp
import com.hyperether.goodjob.addItemMargin
import com.hyperether.goodjob.map.MapComponent
import com.hyperether.goodjob.navigation.ContactDetails
import com.hyperether.goodjob.navigation.Contacts
import com.hyperether.goodjob.repository.IndustryManager
import com.hyperether.goodjob.repository.remote.model.LatLng
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.about_this_contact
import com.hyperether.goodjob.resources.add
import com.hyperether.goodjob.resources.add_new_contact
import com.hyperether.goodjob.resources.address
import com.hyperether.goodjob.resources.building
import com.hyperether.goodjob.resources.city
import com.hyperether.goodjob.resources.contact_deteils
import com.hyperether.goodjob.resources.contact_name_mandatory
import com.hyperether.goodjob.resources.contact_person
import com.hyperether.goodjob.resources.contact_type
import com.hyperether.goodjob.resources.contact_type_24
import com.hyperether.goodjob.resources.country
import com.hyperether.goodjob.resources.delete_contact
import com.hyperether.goodjob.resources.email
import com.hyperether.goodjob.resources.enter_city
import com.hyperether.goodjob.resources.enter_contact_name
import com.hyperether.goodjob.resources.enter_country
import com.hyperether.goodjob.resources.enter_your_email
import com.hyperether.goodjob.resources.enter_zip_code
import com.hyperether.goodjob.resources.ic_mail
import com.hyperether.goodjob.resources.ic_user
import com.hyperether.goodjob.resources.mail
import com.hyperether.goodjob.resources.phone
import com.hyperether.goodjob.resources.phone_24
import com.hyperether.goodjob.resources.save_changes
import com.hyperether.goodjob.resources.use_contact_name
import com.hyperether.goodjob.resources.world_2_svgrepo_com_1
import com.hyperether.goodjob.resources.zip_employee
import com.hyperether.goodjob.scenes.components.AddCustomInputRow
import com.hyperether.goodjob.scenes.components.AddressInputFieldWeb
import com.hyperether.goodjob.scenes.components.IndustrySelectorWeb
import com.hyperether.goodjob.scenes.components.WebViewHeader
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.register.FilledButton
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.DashboardBg
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.Constants.DEFAULT_CONTACT_ID
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import kotlinx.coroutines.delay

@Composable
fun AddNewContactWebScreen(
    navHostController: NavHostController,
    viewModel: AddContactViewModel,
    contactId: String?
) {

    val contact by viewModel.contactWeb.collectAsStateWithLifecycle()
    val allIndustries by IndustryManager.industries.collectAsStateWithLifecycle()
    val focusManager = LocalFocusManager.current
    var formHeight by remember { mutableStateOf(0.dp) }
    val density = LocalDensity.current

    LaunchedEffect(Unit) {
        if (contactId != null) {
            viewModel.fetchWebContactById(contactId)
        }
    }

    LaunchedEffect(contact) {
        delay(500)
        if (contactId != DEFAULT_CONTACT_ID) {
            contact?.let { nullSafeContact ->
                viewModel.contactNameNewContact.value =
                    nullSafeContact.name ?: viewModel.contactNameNewContact.value
                viewModel.contactType.value =
                    viewModel.contactTypeMap.entries
                        .firstOrNull {
                            it.value == nullSafeContact.contactType
                        }?.key ?: ""
                viewModel.industry.value = nullSafeContact.industry ?: viewModel.industry.value
                viewModel.contactCity.value =
                    nullSafeContact.addressObject?.city ?: viewModel.contactCity.value
                viewModel.contactCountry.value =
                    nullSafeContact.addressObject?.country ?: viewModel.contactCountry.value
                viewModel.contactAddress.value =
                    nullSafeContact.addressObject?.address ?: viewModel.contactAddress.value
                viewModel.contactZip.value =
                    nullSafeContact.addressObject?.zip ?: viewModel.contactZip.value
                viewModel.phoneNewContact.value =
                    nullSafeContact.phone ?: viewModel.phoneNewContact.value
                viewModel.emailNewContact.value =
                    nullSafeContact.email ?: viewModel.emailNewContact.value
                viewModel.contactPersonName.value =
                    nullSafeContact.personName ?: viewModel.contactPersonName.value
                viewModel.contactPersonEmail.value =
                    nullSafeContact.personEmail ?: viewModel.contactPersonEmail.value
                viewModel.contactPersonPhone.value =
                    nullSafeContact.personPhone ?: viewModel.contactPersonPhone.value
            }
        } else {
            viewModel.clearContactValues()
        }
    }

    val outerScrollState = rememberScrollState()
    var blockOuterScroll by remember { mutableStateOf(false) }

    Column(
        modifier = Modifier.fillMaxSize().background(DashboardBg)
            .verticalScrollbar(outerScrollState)
            .verticalScroll(
                state = outerScrollState,
                enabled = !blockOuterScroll
            )
            .disableMouseDragScrollOnWeb()
            .padding(bottom = addItemMargin())
    ) {
        val headerTitle = if (contactId == DEFAULT_CONTACT_ID || contactId == "") {
            stringResource(Res.string.add_new_contact)
        } else {
            contact?.name
        }
        WebViewHeader(
            isAddNewContact = true,
            isBackAvailable = true,
            onBackClick = {
                contactId?.let {
                    if (contactId == DEFAULT_CONTACT_ID || contactId == "") {
                        navHostController.navigate(Contacts)
                    } else {
                        navHostController.navigate(ContactDetails(it))
                    }

                }

                viewModel.clearContactValues()
            },
            title = headerTitle ?: "",
            isImportAndAddVisible = false,
            navHostController = navHostController
        )

        val titleText = if (contactId == DEFAULT_CONTACT_ID || contactId == "") {
            stringResource(Res.string.contact_deteils)
        } else {
            stringResource(Res.string.about_this_contact)
        }

        AddNewHeader(
            titleText = titleText,
            showDelete = contactId?.isNotEmpty() == true && contactId != DEFAULT_CONTACT_ID,
            deleteText = stringResource(Res.string.delete_contact),
            onDelete = {
                contactId?.let { contactId ->
                    viewModel.showLoader.value = true
                    viewModel.deleteContact(
                        contactId,
                        onSuccess = {
                            viewModel.showLoader.value = false
                            viewModel.showPopUpSuccessDeleted.value = true
                        },
                        onError = {
                            viewModel.showLoader.value = false
                            viewModel.showPopUpError.value = true
                        })
                }
            }
        ) {
            Column(
                modifier = Modifier.fillMaxWidth().fillMaxHeight()
            ) {
                //form | map
                Row(
                    modifier = Modifier.fillMaxWidth().fillMaxHeight()
                ) {
                    //form
                    Column(
                        modifier = Modifier.weight(1f).fillMaxHeight()
                            .onSizeChanged { size ->
                                formHeight = with(density) { size.height.toDp() }
                            },
                        verticalArrangement = Arrangement.spacedBy(10.toScaleDp())
                    ) {
                        DisableSelection {
                            CustomDropdownMenu(
                                iconRes = Res.drawable.contact_type_24,
                                labelText = stringResource(Res.string.contact_type),
                                placeholderText = stringResource(Res.string.contact_type),
                                items = viewModel.contactTypeMap.keys.toList(),
                                selectedValue = viewModel.contactType.value,
                                onValueSelected = { selectedLabel ->
                                    viewModel.contactType.value = selectedLabel
                                },
                                focusManager = focusManager
                            )
                        }
                        AddCustomInputRow(
                            painterResource = Res.drawable.ic_user,
                            labelText = stringResource(Res.string.contact_name_mandatory),
                            placeholderText = stringResource(Res.string.enter_contact_name),
                            inputValue = viewModel.contactNameNewContact.value,
                            onValueChange = {
                                viewModel.contactNameNewContact.value = it
                            },
                            focusManager = focusManager
                        )
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.offset(x = (-12).toScaleDp())
                                .padding(top = 5.toScaleDp())
                        ) {
                            Checkbox(
                                checked = viewModel.isCheckedContactPerson.value,
                                onCheckedChange = {
                                    viewModel.isCheckedContactPerson.value = it
                                },
                                modifier = Modifier.clip(RoundedCornerShape(50))
                                    .scale(1.toScaleDp().value)
                                    .pointerHoverIcon(PointerIcon.Hand),
                                colors = CheckboxDefaults.colors(
                                    checkedColor = BlueApp,
                                    uncheckedColor = com.hyperether.goodjob.theme.Divider
                                )
                            )
                            Spacer(modifier = Modifier.width(5.toScaleDp()))
                            Text(
                                text = stringResource(Res.string.use_contact_name),
                                color = TextColor,
                                fontSize = 12.toScaleSp(),
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                        AddCustomInputRow(
                            painterResource = Res.drawable.ic_mail,
                            labelText = stringResource(Res.string.email).lowercase()
                                .capitalize(),
                            placeholderText = stringResource(Res.string.enter_your_email),
                            inputValue = viewModel.emailNewContact.value,
                            onValueChange = {
                                viewModel.emailNewContact.value = it
                            },
                            focusManager = focusManager
                        )
                        CustomNumberInputRowUser(
                            painterResource = Res.drawable.phone_24,
                            labelText = stringResource(Res.string.phone),
                            placeholderText = "+1 555 123 4567",
                            placeholderColor = Color.LightGray,
                            inputValue = viewModel.phoneNewContact.value,
                            onValueChange = {
                                viewModel.phoneNewContact.value = it
                            },
                            focusManager = focusManager
                        )
                        AddressInputFieldWeb(
                            textCountry = viewModel.contactCountry,
                            textCity = viewModel.contactCity,
                            text = viewModel.contactAddress,
                            label = stringResource(Res.string.address),
                            modifier = Modifier,
                            onSearch = { viewModel.findPlace(it) },
                            onSelect = {
                                viewModel.contactAddress.value =
                                    it.street ?: it.formattedAddress
                                viewModel.contactZip.value =
                                    it.zip ?: viewModel.contactZip.value
                                viewModel.contactCity.value =
                                    it.city ?: viewModel.contactCity.value
                                viewModel.contactCountry.value =
                                    it.country ?: viewModel.contactCountry.value
                                viewModel.place.value = it
                            },
                            places = viewModel.places,
                            focusManager = focusManager
                        )

                        IndustrySelectorWeb(
                            allIndustries = allIndustries,
                            selectedIndustry = viewModel.industry.value,
                            onIndustrySelected = {
                                viewModel.industry.value = it
                            },
                            onIndustryRemoved = {
                                viewModel.industry.value = null
                            },
                            onAddNewIndustry = { name ->
                                viewModel.industry.value = name
                                IndustryManager.addIndustry(name)
                            },
                            onScrollStart = { blockOuterScroll = true },
                            onScrollEnd = { blockOuterScroll = false }
                        )

                        AddCustomInputRow(
                            painterResource = Res.drawable.building,
                            labelText = stringResource(Res.string.city),
                            placeholderText = stringResource(Res.string.enter_city),
                            inputValue = viewModel.contactCity.value,
                            onValueChange = {
                                viewModel.contactCity.value = it
                            },
                            focusManager = focusManager
                        )
                        AddCustomInputRow(
                            painterResource = Res.drawable.world_2_svgrepo_com_1,
                            labelText = stringResource(Res.string.country),
                            placeholderText = stringResource(Res.string.enter_country),
                            inputValue = viewModel.contactCountry.value,
                            onValueChange = {
                                viewModel.contactCountry.value = it
                            },
                            focusManager = focusManager
                        )
                        AddCustomInputRow(
                            painterResource = Res.drawable.mail,
                            labelText = stringResource(Res.string.zip_employee),
                            placeholderText = stringResource(Res.string.enter_zip_code),
                            inputValue = viewModel.contactZip.value,
                            onValueChange = { newValue ->
                                if (newValue.all { it.isDigit() } && newValue.length <= 12) {
                                    viewModel.contactZip.value = ""
                                    viewModel.contactZip.value = newValue
                                }
                            },
                            focusManager = focusManager
                        )
                        if (viewModel.isCheckedContactPerson.value) {
                            Divider(
                                modifier = Modifier.height(1.toScaleDp()).fillMaxWidth()
                                    .background(Color.LightGray.copy(alpha = 0.1f))
                                    .padding(vertical = 10.toScaleDp())
                            )
                            androidx.compose.material.Text(
                                text = stringResource(Res.string.contact_person),
                                fontSize = Sp(18f),
                                color = TextColor,
                                fontWeight = FontWeight.SemiBold,
                                textAlign = TextAlign.Center,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                            AddCustomInputRow(
                                painterResource = Res.drawable.ic_user,
                                labelText = stringResource(Res.string.contact_name_mandatory),
                                placeholderText = stringResource(Res.string.enter_contact_name),
                                inputValue = viewModel.contactPersonName.value,
                                onValueChange = {
                                    viewModel.contactPersonName.value = it
                                },
                                focusManager = focusManager
                            )
                            AddCustomInputRow(
                                painterResource = Res.drawable.ic_mail,
                                labelText = stringResource(Res.string.email).lowercase()
                                    .capitalize(),
                                placeholderText = stringResource(Res.string.enter_your_email),
                                inputValue = viewModel.contactPersonEmail.value,
                                onValueChange = {
                                    viewModel.contactPersonEmail.value = it
                                },
                                focusManager = focusManager
                            )
                            CustomNumberInputRowUser(
                                painterResource = Res.drawable.phone_24,
                                labelText = stringResource(Res.string.phone),
                                placeholderText = "+1 555 123 4567",
                                inputValue = viewModel.contactPersonPhone.value,
                                onValueChange = {
                                    viewModel.contactPersonPhone.value = it
                                },
                                focusManager = focusManager
                            )
                        }
                    }

                    Spacer(modifier = Modifier.width(20f.toScaleDp()))

                    //map
                    Column(
                        modifier = Modifier
                            .weight(0.6f)
                            .height(if (formHeight > 0.dp) formHeight else 600.toScaleDp())
                            .fillMaxWidth()
                    ) {
                        val currentPosition = mutableStateOf<LatLng?>(null)
                        viewModel.place.value?.let {
                            currentPosition.value =
                                LatLng(it.location.latitude, it.location.longitude)
                            //TODO maybe we should make marker here because when you are making new site viewModel.getRemoteSiteMarkers() returns empty list
                        }
                        MapComponent(
                            showMapWeb = mutableStateOf(true),
                            showMap = true,
                            markers = viewModel.getContactMarkers(),
                            currentPosition = currentPosition
                        )
                    }
                }

                //submit
                Column(modifier = Modifier.fillMaxWidth()) {
                    Spacer(modifier = Modifier.height(15.toScaleDp()))
                    Row(modifier = Modifier.fillMaxWidth()) {
                        FilledButton(
                            onClick = {
                                viewModel.showLoader.value = true
                                if (contactId == DEFAULT_CONTACT_ID || contactId == "") {
                                    viewModel.addContact(onSuccess = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpSuccess.value = true
                                    }, onError = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpError.value = true
                                    })
                                } else {
                                    viewModel.updateContact(onSuccess = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpSuccess.value = true
                                    }, onError = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpError.value = true
                                    })
                                }
                            },
                            text = if (contactId == DEFAULT_CONTACT_ID || contactId.isNullOrEmpty()) stringResource(
                                Res.string.add
                            ) else stringResource(
                                Res.string.save_changes
                            ),
                            isEnabled = true,
                            modifier = Modifier.weight(1f)
                        )
                        Spacer(modifier = Modifier.width(20f.toScaleDp()))
                        Spacer(modifier = Modifier.weight(0.6f))
                    }
                    Spacer(modifier = Modifier.height(20.toScaleDp()))
                }
            }
        }
    }
}
